// Blog2024.jsx에서 테이블명과 라우트만 바꾼 버전
import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Blog.css';

function Blog2025() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      let query = supabase
        .from('blog_posts_2025')
        .select('id, title, summary, slug, created_at, thumbnail, is_hidden')
        .order('created_at', { ascending: false });

      if (!isAdmin) {
        query = query.eq('is_hidden', false);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching 2025 posts:', error);
      } else {
        setPosts(data);
      }
      setLoading(false);
    };

    fetchPosts();
  }, [isAdmin]);

  const handleToggleHidden = async (id, currentHidden) => {
    const next = !currentHidden;
    const { error } = await supabase
      .from('blog_posts_2025')
      .update({ is_hidden: next })
      .eq('id', id);
    if (error) {
      alert('숨김 상태 변경 중 오류가 발생했습니다.');
      return;
    }
    setPosts((prev) => prev.map((p) => (p.id === id ? { ...p, is_hidden: next } : p)));
  };

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h2 className="blog-title">Blog 2025</h2>
        {isAdmin && (
          <button className="write-post-btn" onClick={() => navigate('/blog/new')}>
            글 작성
          </button>
        )}
      </div>

      {loading ? (
        <p>로딩 중...</p>
      ) : posts.length === 0 ? (
        <p>작성된 글이 없습니다.</p>
      ) : (
        <ul className="blog-list">
          {posts.map((post) => (
            <li
              key={post.id}
              className={`blog-item ${post.is_hidden ? 'is-hidden-post' : ''}`}
            >
              <Link to={`/blog/2025/${post.slug}`} className="blog-link">
                <div className="blog-text-content">
                  <h3>
                    {post.title}
                    {post.is_hidden && isAdmin && (
                      <span className="hidden-badge">숨김</span>
                    )}
                  </h3>
                  <p className="blog-summary">{post.summary}</p>
                  <span className="blog-date">
                    {new Date(post.created_at).toLocaleDateString()}
                  </span>
                </div>
                <img
                  src={post.thumbnail || '/butterfly.png'}
                  alt="썸네일"
                  className="blog-thumbnail"
                />
              </Link>
              {isAdmin && (
                <div className="admin-post-controls">
                  <button
                    className="hide-post-btn"
                    onClick={() => handleToggleHidden(post.id, post.is_hidden)}
                  >
                    {post.is_hidden ? '공개' : '숨김'}
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Blog2025;
